import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 32px;
  font-family: Arial, sans-serif;
  line-height: 1.5;
  color: #333;
  background: #F2EBE6;
`;

const Section = styled.section`
  margin-bottom: 24px;
`;

const Heading1 = styled.h2`
  font-size: 1.25rem;
  margin-top: 24px;
  margin-bottom: 8px;
`;

const Heading2 = styled.h3`
  font-size: 1rem;
  margin-top: 16px;
  margin-bottom: 4px;
`;

const Paragraph = styled.p`
  margin: 8px 0;
`;

const List = styled.ol`
  margin: 8px 0 8px;
  list-style: none;
`;

const ListItem = styled.li`
  margin: 4px 0;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 16px 0;
`;

const TH = styled.th`
  text-align: left;
  vertical-align: top;
  padding: 8px;
  border: 1px solid #ddd;
  width: 30%;
`;

const TD = styled.td`
  padding: 8px;
  border: 1px solid #ddd;
`;

export default function PrivacyPolicy() {
  return (
    <Container>
      <Heading1>Политика в отношении обработки персональных данных</Heading1>

      {/* 1 */}
      <Section>
        <Heading2>1. Общие положения</Heading2>
        <Paragraph>
          Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона
          от 27.07.2006. № 152-ФЗ «О персональных данных» (далее — Закон о персональных данных) и определяет порядок
          обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые
          Шурмистровым Павлом Васильевичем (далее — Оператор). </Paragraph>
        <List>
          <ListItem>
            1.1 Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и
            свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на
            неприкосновенность частной жизни, личную и семейную тайну.
          </ListItem>
          <ListItem>
            Настоящая политика Оператора в отношении обработки персональных данных (далее — Политика) применяется ко
            всей информации, которую Оператор может получить о посетителях веб-сайта https://myft.ru.
          </ListItem>
        </List>
      </Section>

      {/* 2 */}
      <Section>
        <Heading2>2. Основные понятия, используемые в Политике</Heading2>
        <List>
          <ListItem>
            <strong>2.1. Автоматизированная обработка персональных данных</strong> — обработка персональных данных с
            помощью средств вычислительной техники.
          </ListItem>
          <ListItem>
            <strong>2.2. Блокирование персональных данных</strong> — временное прекращение обработки персональных данных
            (за исключением случаев, если обработка необходима для уточнения персональных данных).
          </ListItem>
          <ListItem>
            <strong>2.3. Веб‑сайт</strong> — совокупность графических и информационных материалов, а также программ для
            ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу https://myft.ru.
          </ListItem>
          <ListItem>
            <strong>2.4. Информационная система персональных данных</strong> — совокупность содержащихся в базах данных
            персональных данных и обеспечивающих их обработку информационных технологий и технических средств.
          </ListItem>
          <ListItem>
            <strong>2.5. Обезличивание персональных данных</strong> — действия, в результате которых невозможно
            определить без использования дополнительной информации принадлежность персональных данных конкретному
            Пользователю или иному субъекту персональных данных.
          </ListItem>
          <ListItem>
            <strong>2.6. Обработка персональных данных</strong> — любое действие (операция) или совокупность действий
            (операций), совершаемых с использованием средств автоматизации или без использования таких средств с
            персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление,
            изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание,
            блокирование, удаление, уничтожение персональных данных.
          </ListItem>
          <ListItem>
            <strong>2.7. Оператор</strong> — государственный орган, муниципальный орган, юридическое или физическое
            лицо, самостоятельно или совместно с другими лицами организующие и/или осуществляющие обработку персональных
            данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих
            обработке, действия (операции), совершаемые с персональными данными.
          </ListItem>
          <ListItem>
            <strong>2.8. Персональные данные</strong> — любая информация, относящаяся прямо или косвенно к определенному
            или определяемому Пользователю веб‑сайта https://myft.ru.
          </ListItem>
          <ListItem>
            <strong>2.9. Персональные данные, разрешенные субъектом персональных данных для распространения</strong> —
            персональные данные, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных
            путем дачи согласия на
            обработку персональных данных, разрешенных субъектом персональных данных для распространения в порядке,
            предусмотренном Законом о персональных данных (далее — персональные данные, разрешенные для
            распространения).
          </ListItem>
          <ListItem>
            <strong>2.10. Пользователь</strong> — любой посетитель веб‑сайта https://myft.ru.
          </ListItem>
          <ListItem>
            <strong>2.11. Предоставление персональных данных</strong> — действия, направленные на раскрытие персональных
            данных определенному лицу или определенному кругу лиц.
          </ListItem>
          <ListItem>
            <strong>2.12. Распространение персональных данных</strong> — любые действия, направленные на раскрытие
            персональных данных неопределенному кругу лиц (передача персональных данных) или на ознакомление с
            персональными данными неограниченного круга лиц, в том числе обнародование персональных данных в средствах
            массовой информации, размещение в информационно‑телекоммуникационных сетях или предоставление доступа к
            персональным данным каким-либо иным способом.
          </ListItem>
          <ListItem>
            <strong>2.13. Трансграничная передача персональных данных</strong> — передача персональных данных на
            территорию иностранного государства органу власти иностранного государства, иностранному физическому или
            иностранному юридическому лицу.
          </ListItem>
          <ListItem>
            <strong>2.14. Уничтожение персональных данных</strong> — любые действия, в результате которых персональные
            данные уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных
            в информационной системе персональных данных и/или уничтожаются материальные носители персональных данных.
          </ListItem>
        </List>
      </Section>

      {/* 3 */}
      <Section>
        <Heading2>3. Основные права и обязанности Оператора</Heading2>
        <List>
          <ListItem>
            <strong>3.1. Оператор имеет право:</strong>
            <List as="ol">
              <ListItem>получать от субъекта персональных данных достоверные информацию и/или документы, содержащие
                персональные данные;</ListItem>
              <ListItem>в случае отзыва субъектом персональных данных согласия на обработку персональных данных, а также
                направления обращения с требованием о прекращении обработки персональных данных, Оператор вправе
                продолжить обработку персональных данных без согласия субъекта персональных данных при наличии
                оснований, указанных в Законе о персональных данных;</ListItem>
              <ListItem>самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения
                выполнения обязанностей, предусмотренных Законом о персональных данных и принятыми в соответствии с ним
                нормативными правовыми актами, если иное не предусмотрено Законом о персональных данных или другими
                федеральными законами.</ListItem>
            </List>
          </ListItem>
          <ListItem>
            <strong>3.2. Оператор обязан:</strong>
            <List as="ol">
              <ListItem>предоставлять субъекту персональных данных по его просьбе информацию, касающуюся обработки его
                персональных данных;</ListItem>
              <ListItem>организовывать обработку персональных данных в порядке, установленном действующим
                законодательством РФ;</ListItem>
              <ListItem>отвечать на обращения и запросы субъектов персональных данных и их законных представителей в
                соответствии с требованиями Закона о персональных данных;</ListItem>
              <ListItem>сообщать в уполномоченный орган по защите прав субъектов персональных данных по запросу этого
                органа необходимую информацию в течение 10 дней с даты получения такого запроса;</ListItem>
              <ListItem>публиковать или иным образом обеспечивать неограниченный доступ к настоящей Политике в отношении
                обработки персональных данных;</ListItem>
              <ListItem>принимать правовые, организационные и технические меры для защиты персональных данных от
                неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования,
                предоставления, распространения персональных данных, а также от иных неправомерных действий в отношении
                персональных данных;</ListItem>
              <ListItem>прекратить передачу (распространение, предоставление, доступ) персональных данных, прекратить
                обработку и уничтожить персональные данные в порядке и случаях, предусмотренных Законом о персональных
                данных;</ListItem>
              <ListItem>исполнили иные обязанности, предусмотренные Законом о персональных данных.</ListItem>
            </List>
          </ListItem>
        </List>
      </Section>

      {/* 4 */}
      <Section>
        <Heading2>4. Основные права и обязанности субъектов персональных данных</Heading2>
        <List>
          <ListItem>
            <strong>4.1. Субъекты персональных данных имеют право:</strong>
            <List as="ol">
              <ListItem>— получать информацию, касающуюся обработки его персональных данных, за исключением случаев,
                предусмотренных федеральными законами. Сведения предоставляются субъекту персональных данных Оператором
                в доступной форме, и в них не должны содержаться персональные данные, относящиеся к другим субъектам
                персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких
                персональных данных. Перечень информации и порядок её получения установлен в законе о персональных
                данных;</ListItem>
              <ListItem>— требовать от оператора уточнения его персональных данных, их блокирования или уничтожения в
                случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или
                не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры
                по защите своих прав;</ListItem>
              <ListItem>— выдвигать условие предварительного согласия при обработке персональных данных в целях
                продвижения на рынке товаров, работ и услуг;</ListItem>
              <ListItem>— на отзыв согласия на обработку персональных данных, а также на направление требования о
                прекращении обработки персональных данных;</ListItem>
              <ListItem>— обжаловать в уполномоченный орган по защите прав субъектов персональных данных или в судебном
                порядке неправомерные действия или бездействие Оператора при обработке его персональных
                данных;</ListItem>
              <ListItem>— на осуществление иных прав, предусмотренных законодательством РФ.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>4.2. Субъекты персональных данных обязаны:</strong>
            <List as="ol">
              <ListItem>— предоставлять Оператору достоверные данные о себе;</ListItem>
              <ListItem>— сообщать Оператору об уточнении (обновлении, изменении) своих персональных данных.</ListItem>
            </List>
          </ListItem>

          <ListItem>
            <strong>4.3.</strong> Лица, передавшие Оператору недостоверные сведения о себе, либо сведения о другом
            субъекте персональных данных без согласия последнего, несут ответственность в соответствии с
            законодательством РФ.
          </ListItem>
        </List>
      </Section>

      {/* 5 */}
      <Section>
        <Heading2>5. Принципы обработки персональных данных</Heading2>
        <List>
          <ListItem>5.1. Обработка персональных данных осуществляется на законной и справедливой основе.</ListItem>
          <ListItem>5.2. Обработка персональных данных ограничивается достижением конкретных, заранее определенных и
            законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных
            данных.</ListItem>
          <ListItem>5.3. Не допускается объединение баз данных, содержащих персональные данные, обработка которых
            осуществляется в целях, несовместимых между собой.</ListItem>
          <ListItem>5.4. Обработке подлежат только персональные данные, которые отвечают целям их обработки.</ListItem>
          <ListItem>5.5. Содержание и объем обрабатываемых персональных данных соответствуют заявленным целям обработки
            персональных данных. Не допускается избыточность обрабатываемых персональных данных по отношению к
            заявленным целям их обработки.</ListItem>
          <ListItem>5.6. При обработке персональных данных обеспечивается точность персональных данных, их
            достаточность, а в необходимых случаях и актуальность по отношению к целям обработки персональных данных.
            Оператор принимает необходимые меры и/или обеспечивает их принятие по удалению или уточнению неполных или
            неточных данных.</ListItem>
          <ListItem>5.7. Хранение персональных данных осуществляется в форме, позволяющей определить субъекта
            персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения
            персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем
            или поручителем по которому является субъект персональных данных. Обрабатываемые персональные данные
            уничтожаются либо обезличиваются по достижении целей обработки или в случае утраты необходимости в
            достижении этих целей, если иное не предусмотрено федеральным законом.</ListItem>
        </List>
      </Section>

      {/* 6 */}
      <Section>
        <Heading2>6. Цели обработки персональных данных</Heading2>
        <StyledTable>
          <tbody>
          <tr>
            <TH>Цель обработки</TH>
            <TD>предоставление доступа Пользователю к сервисам, информации и/или материалам, содержащимся на веб‑сайте</TD>
          </tr>
          <tr>
            <TH>Персональные данные</TH>
            <TD>
              <List>
                <ListItem>фамилия, имя, отчество</ListItem>
                <ListItem>электронный адрес</ListItem>
                <ListItem>год, месяц, дата и место рождения</ListItem>
                <ListItem>фотографии</ListItem>
                <ListItem>сведения о семейном положении и составе семьи</ListItem>
              </List>
            </TD>
          </tr>
          <tr>
            <TH>Правовые основания</TH>
            <TD>Федеральный закон «Об информации, информационных технологиях и о защите информации» от 27.07.2006 N 149‑ФЗ</TD>
          </tr>
          <tr>
            <TH>Виды обработки персональных данных</TH>
            <TD>
              <List>
                <ListItem>Сбор, запись, систематизация, накопление, хранение, уничтожение и обезличивание персональных данных</ListItem>
                <ListItem>Отправка информационных писем на адрес электронной почты</ListItem>
              </List>
            </TD>
          </tr>
          </tbody>
        </StyledTable>
      </Section>

      {/* 7 */}
      {/* 7 */}
      <Section>
        <Heading2>7. Условия обработки персональных данных</Heading2>
        <List>
          <ListItem>7.1. Обработка персональных данных осуществляется с согласия субъекта персональных данных на
            обработку его персональных данных.</ListItem>
          <ListItem>7.2. Обработка персональных данных необходима для достижения целей, предусмотренных международным
            договором Российской Федерации или законом, для осуществления возложенных законодательством Российской
            Федерации на оператора функций, полномочий и обязанностей.</ListItem>
          <ListItem>7.3. Обработка персональных данных необходима для осуществления правосудия, исполнения судебного
            акта, акта другого органа или должностного лица, подлежащих исполнению в соответствии с законодательством
            Российской Федерации об исполнительном производстве.</ListItem>
          <ListItem>7.4. Обработка персональных данных необходима для исполнения договора, стороной которого либо
            выгодоприобретателем или поручителем по которому является субъект персональных данных, а также для
            заключения договора по инициативе субъекта персональных данных или договора, по которому субъект
            персональных данных будет являться выгодоприобретателем или поручителем.</ListItem>
          <ListItem>7.5. Обработка персональных данных необходима для осуществления прав и законных интересов оператора
            или третьих лиц либо для достижения общественно значимых целей при условии, что при этом не нарушаются права
            и свободы субъекта персональных данных.</ListItem>
          <ListItem>7.6. Осуществляется обработка персональных данных, доступ неограниченного круга лиц к которым
            предоставлен субъектом персональных данных либо по его просьбе (далее — общедоступные персональные
            данные).</ListItem>
          <ListItem>7.7. Осуществляется обработка персональных данных, подлежащих опубликованию или обязательному
            раскрытию в соответствии с федеральным законом.</ListItem>
        </List>
      </Section>

      {/* 8 */}
      <Section>
        <Heading2>8. Порядок сбора, хранения, передачи и других видов обработки персональных данных</Heading2>
        <Paragraph>
          Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых,
          организационных и технических мер, необходимых для выполнения в полном объеме требований действующего
          законодательства в области защиты персональных данных.
        </Paragraph>
        <List>
          <ListItem>8.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры,
            исключающие доступ к персональным данным неуполномоченных лиц.</ListItem>
          <ListItem>8.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим
            лицам, за исключением случаев, связанных с исполнением действующего законодательства либо в случае, если
            субъектом персональных данных дано согласие Оператору на передачу данных третьему лицу для исполнения
            обязательств по гражданско-правовому договору.</ListItem>
          <ListItem>8.3. В случае выявления неточностей в персональных данных, Пользователь может актуализировать их
            самостоятельно, путем направления Оператору уведомление на адрес электронной почты Оператора
            admin@myft.ru с пометкой «Актуализация персональных данных».</ListItem>
          <ListItem>8.4. Срок обработки персональных данных определяется достижением целей, для которых были собраны
            персональные данные, если иной срок не предусмотрен договором или действующим законодательством.</ListItem>
        </List>
        <Paragraph>
          Пользователь может в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору
          уведомление посредством электронной почты на электронный адрес Оператора admin@myft.ru с пометкой
          «Отзыв согласия на обработку персональных данных».
        </Paragraph>
        <List start={5}>
          <ListItem>8.5. Вся информация, которая собирается сторонними сервисами, в том числе платежными системами,
            средствами связи и другими поставщиками услуг, хранится и обрабатывается указанными лицами (Операторами) в
            соответствии с их Пользовательским соглашением и Политикой конфиденциальности. Субъект персональных данных
            и/или с указанными документами. Оператор не несет ответственность за действия третьих лиц, в том числе
            указанных в настоящем пункте поставщиков услуг.</ListItem>
          <ListItem>8.6. Установленные субъектом персональных данных запреты на передачу (кроме предоставления доступа),
            а также на обработку или условия обработки (кроме получения доступа) персональных данных, разрешенных для
            распространения, не действуют в случаях обработки персональных данных в государственных, общественных и иных
            публичных интересах, определенных законодательством РФ.</ListItem>
          <ListItem>8.7. Оператор при обработке персональных данных обеспечивает конфиденциальность персональных
            данных.</ListItem>
          <ListItem>8.8. Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта
            персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения
            персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем
            или поручителем по которому является субъект персональных данных.</ListItem>
          <ListItem>8.9. Условием прекращения обработки персональных данных может являться достижение целей обработки
            персональных данных, истечение срока действия согласия субъекта персональных данных, отзыв согласия
            субъектом персональных данных или требование о прекращении обработки персональных данных, а также выявление
            неправомерной обработки персональных данных.</ListItem>
        </List>
      </Section>


      {/* 9 */}
      {/* 9 */}
      <Section>
        <Heading2>9. Перечень действий, производимых Оператором с полученными персональными данными</Heading2>
        <List>
          <ListItem>9.1. Оператор осуществляет сбор, запись, систематизацию, накопление, хранение, уточнение
            (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ),
            обезличивание, блокирование, удаление и уничтожение персональных данных.</ListItem>
          <ListItem>9.2. Оператор осуществляет автоматизированную обработку персональных данных с получением и/или
            передачей полученной информации по информационно-телекоммуникационным сетям или без таковой.</ListItem>
        </List>
      </Section>

      {/* 10 */}
      <Section>
        <Heading2>10. Трансграничная передача персональных данных</Heading2>
        <List>
          <ListItem>10.1. Оператор до начала осуществления деятельности по трансграничной передаче персональных данных
            обязан уведомить уполномоченный орган по защите прав субъектов персональных данных о своем намерении
            осуществлять трансграничную передачу персональных данных (такое уведомление направляется отдельно от
            уведомления о намерении осуществлять обработку персональных данных).</ListItem>
          <ListItem>10.2. Оператор до подачи вышеуказанного уведомления, обязан получить от органов власти иностранного
            государства, иностранных физических лиц, иностранных юридических лиц, которым планируется трансграничная
            передача персональных данных, соответствующие сведения.</ListItem>
        </List>
      </Section>

      {/* 11 */}
      <Section>
        <Heading2>11. Конфиденциальность персональных данных</Heading2>
        <Paragraph>
          Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим лицам и не
          распространять персональные данные без согласия субъекта персональных данных, если иное не предусмотрено
          федеральным законом.
        </Paragraph>
      </Section>

      {/* 12 */}
      <Section>
        <Heading2>12. Заключительные положения</Heading2>
        <List>
          <ListItem>12.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки
            его персональных данных, обратившись к Оператору с помощью электронной почты admin@myft.ru.</ListItem>
          <ListItem>12.2. В данном документе будут отражены любые изменения политики обработки персональных данных
            Оператором. Политика действует бессрочно до замены ее новой версией.</ListItem>
          <ListItem>12.3. Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу
            https://myft.ru/privacy.</ListItem>
        </List>
      </Section>

    </Container>
  );
}
